var _ = require('underscore');
var ko = require('knockout');

var Filter = require('./filter.js');
var FilterGroup = require('./filter_group.js');
var viewModelBase = require('../tk/view_model/base.js');

// A view model that constructs and maintains all filters and groups.
//
// apiFonts    - Fonts to use for filters.
// filtersData - JSON data representing the filters.
// seedData    - Hash of 'namespace.value' to opaque ids to seed with
//
module.exports = viewModelBase.create({
  init: function(apiFonts, filtersData, seedData) {
    this.filters = [];
    this.filterGroups = [];

    // Turn data into Filter and FilterGroup objects.
    (function() {
      var namespaces = {};

      // Build filters
      var filters = _.map(filtersData, function(item) {
        var filter = new Filter(apiFonts, {
          fvd: item.fvd,
          label: item.label,
          namespace: item.namespace,
          preventDeselect: item.prevent_deselect,
          scripts: item.scripts,
          value: item.value
        });

        // Track whether filter groups are checkbox or radio.
        filter.isCheckbox(item.is_checkbox || false);
        if (!namespaces[filter.namespace]) {
          namespaces[filter.namespace] = item.is_checkbox;
        }

        // Look for seed data to pass in.
        var opaqueIds = seedData[[filter.namespace, filter.value].join('.')];
        if (opaqueIds) filter.setOpaqueIds(opaqueIds);

        // Enable the filter.
        filter.isEnabled(!!item.is_enabled);

        return filter;
      }, this);

      // Build filter groups
      var groupsIndex = {};
      var filterGroups = _.map(namespaces, function(isCheckbox, namespace) {
        var group = new FilterGroup(namespace, isCheckbox);
        groupsIndex[namespace] = group;
        return group;
      }, this);

      // Connect filters and groups.
      _.each(filters, function(filter) {
        groupsIndex[filter.namespace].addFilter(filter);
      });

      // Store instances.
      this.filters = filters;
      this.filterGroups = filterGroups;
    }).bind(this)();

    this.enabledFilters = ko.computed({
      read: this._enabledFilters_read,
      write: this._enabledFilters_write,
      owner: this
    });
  },

  // Public: Set a state handler for all of the filters.
  //
  // stateHandler - StateHandler to set.
  //
  // Returns nothing.
  useStateHandler: function(stateHandler) {
    _.each(this.filters, function(filter) {
      filter.useStateHandler(stateHandler);
    });
  },

  // Public: Get a FilterGroup.
  //
  // namespace - String namespace that the filter group represents.
  //
  // Returns a FilterGroup or null.
  getFilterGroup: function(namespace) {
    return _.detect(this.filterGroups, function(f) { return f.namespace == namespace; });
  },

  // Public: Get some filters.
  //
  // namespace - String namespace or Array of namespaces that filters belong to.
  //
  // Returns an Array of Filter.
  filtersFor: function(namespace) {
    if (_.isArray(namespace)) {
      return _.select(this.filters, function(f) { return _.include(namespace, f.namespace); });
    } else {
      return _.select(this.filters, function(f) { return f.namespace == namespace; });
    }
  },

  // Read enabledFilters.
  //
  // Returns the Filters that are enabled across all groups.
  _enabledFilters_read: function() {
    return _.select(this.filters, function(f) { return f.isEnabled(); });
  },

  // Write enabledFilters.
  //
  // filters - Array of Filters to enable across all groups.
  //
  // Returns nothing.
  _enabledFilters_write: function(filters) {
    var grouped = {};
    _.each(filters, function(filter) {
      if (!grouped[filter.namespace]) grouped[filter.namespace] = [];
      grouped[filter.namespace].push(filter);
    });
    _.each(this.filterGroups, function(group) {
      group.enabledFilters(grouped[group.namespace] || []);
    });
  }
});
